/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';
export const SELECTED_CREDENTIALS = gql`
mutation Mutation($filter: UniqStudPortfolioFilterInput!, $update: StudPortfolioUpdateInput!) {
  updateStudPortfolio(filter: $filter, update: $update) {
    credentials
    uuid
    userGroup
    updatedAt
    socialLinks
    state
    recommendation
    name
    logo
    id
    goal
    feedback
    email
    display
    description
    createdAt
    bannerImage
  }
}
`;
